import PageManipulationOverlay from './PageManipulationOverlayContainer';

export default PageManipulationOverlay;